export default {"src":"/_next/static/media/circleDamage_24.68590a5e.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};